import React from 'react'
import { FormattedMessage } from 'react-intl'

import { useLocale } from '../../../../../../../../hooks/use-locale'
import { percentage } from '../../../../../../../../utils'

const Information = ({ ownerFees }: { ownerFees: number }) => {
  const { locale } = useLocale()
  return (
    <div>
      <p>
        <FormattedMessage
          id='ui.UploadQuotationModal.Information.bookingBecomesEffective'
          defaultMessage='Toute réservation devient effective dès lors que le paiement de l’acompte est effectué'
        />
      </p>
      <br />
      <p className='font-bold'>
        <FormattedMessage
          id='ui.UploadQuotationModal.Information.ownerFees'
          defaultMessage='Nous facturons une commission de {ownerFees} HT sur le facturé HT'
          values={{ ownerFees: percentage({ rate: ownerFees, locale }) }}
        />
      </p>
    </div>
  )
}

export default Information
